import { cloneElement } from "react";
import { Placement } from "react-aria";
import { DialogTrigger, type PopoverProps } from "react-aria-components";
import { MDSMenuDropdownPopover } from "./menu-dropdown.styles";
import { getSlot } from "@/mds/utils/slots";
import { MDSMenuDropdownSlotName } from "./menu-dropdown.types";

export interface MDSMenuDropdownProps {
  children: React.ReactNode;
  placement?: Placement;
  isOpen?: boolean;
  onOpenChange?: (isOpen: boolean) => void;
  popoverProps?: Omit<PopoverProps, "children" | "placement"> & {
    "data-test-id"?: string;
  };
}

export const MDSMenuDropdown = ({
  children,
  placement,
  isOpen,
  onOpenChange,
  popoverProps,
}: MDSMenuDropdownProps) => {
  const trigger = getSlot(children, MDSMenuDropdownSlotName.Trigger);
  const menu = getSlot(children, MDSMenuDropdownSlotName.Menu);

  // Strip the slot prop from trigger to prevent React Aria slot context conflicts
  // when MDSMenuDropdown is used inside a Dialog (which has its own slot context)
  const triggerWithoutSlot = trigger ? cloneElement(trigger, { slot: undefined }) : null;

  return (
    <DialogTrigger isOpen={isOpen} onOpenChange={onOpenChange}>
      {triggerWithoutSlot}
      <MDSMenuDropdownPopover {...popoverProps} placement={placement ?? "bottom start"}>
        {menu}
      </MDSMenuDropdownPopover>
    </DialogTrigger>
  );
};
